module.exports = __webpack_public_path__ + "static/incubus-7d0be6c55321f556a6194d4bed218264.png";